import { render, staticRenderFns } from "./useRepert.vue?vue&type=template&id=a1125930"
import script from "./useRepert.vue?vue&type=script&lang=js"
export * from "./useRepert.vue?vue&type=script&lang=js"
import style0 from "./useRepert.vue?vue&type=style&index=0&id=a1125930&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports